import { Component, OnInit, Inject } from '@angular/core';
import {FormControl,Validators,FormGroup} from '@angular/forms';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { SettingService } from '../../_service/setting.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-lead-assignment-setting-modal',
  templateUrl: './lead-assignment-setting-modal.component.html',
  styleUrls: ['./lead-assignment-setting-modal.component.css']
})
export class LeadAssignmentSettingModalComponent implements OnInit {
  circle_id:any;modaldata:any;bds=[];catergory_id:any;
  BdsControl: FormControl;submitted = false;
  selectedChips: any[] = [];
  selectable = true;
  selectedObjects = [];loading:boolean=false;
  spinner_loader:boolean=true;
  constructor(private settingapi:SettingService, private leadapi:LeadsService,private sharedapi:SharedService,public dialogRef: MatDialogRef<LeadAssignmentSettingModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog) { 
    this.modaldata=data;
    console.log(this.modaldata);
    this.circle_id= this.modaldata.circle_id;
    this.catergory_id= this.modaldata.catergory_id;
    if(this.circle_id){
      this.assignedBds(this.circle_id,this.catergory_id);
      this.patchData();
    }
    this.BdsControl = new FormControl('')
  }

  async patchData(){
    let Data = {
      'circle_id':this.circle_id,
      'category_id':this.catergory_id
      
    }
    await this.settingapi.fetchAssignedBdsData(Data).subscribe((response:any) => {
      if(response.status){
        this.spinner_loader=false;
        this.selectedObjects=response.data;
      }

    })  
  }

  compareFn(user1: any, user2: any) {
    return user1 && user2 ? user1.id === user2.id : user1 === user2;
  }

  submitData() {
    console.log(this.BdsControl);
    this.submitted = true;
    this.loading = true;
   
    // stop here if form is invalid
    if (this.BdsControl.invalid) {
       this.loading = false;
       return;
    }
    if(this.BdsControl.value){
      var DataArray=[];
      this.BdsControl.value.forEach(element => {
          DataArray.push({
            'user_id':element.id
          })
      });
    } 
    
    this.settingapi.addAssignedSetting(DataArray,this.catergory_id,this.circle_id)
    .subscribe((data:any) => {
       this.submitted = false;
       this.loading = false;
       if(data.status)
       {
         if(data.code==200){
            this.sharedapi.presentToast('Data Assigned Successfully');
         }
         setTimeout(() => {
          this.CloseModal();
        }, 2000);
      }
       else
       {
           this.sharedapi.presentToast(data.msg);
       }
     }, error => 
       {
           this.sharedapi.checkError(error);
    });
  }

  onToppingRemoved(bds: string) {
    console.log(bds);
    const bdsData = this.BdsControl.value as string[];
    console.log(bdsData);
    this.removeFirst(bdsData, bds);
    this.BdsControl.setValue(bdsData); // To trigger change detection
    
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  async assignedBds(circle_id,category_id){
    let qString = 'circle='+circle_id+'&category='+category_id;
    await this.leadapi.getcatcirclewisebds(qString).subscribe((data:any) => {
      if(data.status)
        {
           this.bds = data.data;
        }else{
            this.bds = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
}


  ngOnInit(): void {
   
  }  
}
